// /url-shortener-frontend/src/config.js
const ENV = process.env.NODE_ENV || 'production';

const CONFIG = {
  development: {
    API_BASE_URL: 'http://192.168.231.32:5000',
    BASE_URL: 'http://192.168.231.32:5000'
  },
  production: {
    API_BASE_URL: window.location.origin,
    BASE_URL: window.location.origin
  }
};

export default CONFIG[ENV];
